module.exports = __webpack_public_path__ + "static/troglodyte-dmg-0850df6d907b79dd7df3696a47cf686f.png";